import { adt, iots, struct } from '@code-expert/prelude';
import { UserId } from '/imports/domain/identity';
import { Legi } from '/imports/domain/legi';
import type { ExamineeId, User } from '/imports/domain/user';

export interface EdozExaminee {
  _tag: 'edoz';
  legi: Legi;
  firstname: string;
  lastname: string;
  email: string;
}

export const EdozExaminee = iots.strict({
  _tag: iots.literal('edoz'),
  legi: Legi,
  firstname: iots.string,
  lastname: iots.string,
  email: iots.string,
}) satisfies iots.Type<EdozExaminee, unknown>;

export const isEdozExaminee = (u: Examinee): u is EdozExaminee => u._tag === 'edoz';

export interface CourseExaminee {
  _tag: 'course';
  userId: UserId;
  firstname: string;
  lastname: string;
  email: string;
}

export const CourseExaminee = iots.strict({
  _tag: iots.literal('course'),
  userId: UserId,
  firstname: iots.string,
  lastname: iots.string,
  email: iots.string,
}) satisfies iots.Type<CourseExaminee, unknown>;

export const isCourseExaminee = (u: Examinee): u is CourseExaminee => u._tag === 'course';

export type Examinee = EdozExaminee | CourseExaminee;

export const Examinee = iots.union([EdozExaminee, CourseExaminee]) satisfies iots.Type<
  Examinee,
  unknown
> satisfies iots.Type<Examinee, unknown>;

export const foldExaminee = adt.foldFromTags<Examinee, '_tag'>('_tag');

export const toExamineeId = (x: Examinee): ExamineeId =>
  foldExaminee<ExamineeId>(x, {
    edoz: struct.pick(['_tag', 'legi']),
    course: struct.pick(['_tag', 'userId']),
  });

export const courseExamineeFromUser = (
  u: Pick<User, '_id' | 'firstname' | 'lastname' | 'email'>,
): CourseExaminee => ({
  _tag: 'course',
  userId: u._id,
  firstname: u.firstname,
  lastname: u.lastname,
  email: u.email,
});
